<template>
  <div class="rc-content-table">
    <label class="item-name">{{initComponent.name}}</label>
    <div class="grid-wrapper" :style="getStyle">
      <div class="item" v-for="index in getDivNumber" :key="index" @drop.stop="drop($event, index)" @click="click($event, index)">
        <template v-if="getComponent(index)">
          <span v-show="getComponent(index).attr.required" class="required">*</span>
          <i class="el-icon-delete table" @click.stop="removeComponent(index)"></i>
          <component
            :is="getComponent(index).componentType"
            :initComponent="getComponent(index)">
          </component>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import RcInput from '../input/rc-input.vue'
import RcNumeric from '../numeric/rc-numeric.vue'
import RcLabel from '../label/rc-label.vue'
import RcCombobox from '../combobox/rc-combobox.vue'
import RcHyperlink from '../hyperlink/rc-hyperlink.vue'
import RcIdCard from '../idcard/rc-id-card.vue'
import RcChildrenInput from '../input/rc-children-input.vue'
import RcDate from '../date/rc-date.vue'
import { componentMixin } from '../mixins'

export default {
  name: 'rc-content-table',
  props: ['initComponent', 'height'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent,
      numberOfColumns: parseInt(this.initComponent.attr.numberOfColumns)
    }
  },
  components: {
    RcInput,
    RcNumeric,
    RcLabel,
    RcCombobox,
    RcHyperlink,
    RcIdCard,
    RcChildrenInput,
    RcDate
  },
  methods: {
    drop (event, index) {
      // let transferData = JSON.parse(event.dataTransfer.getData('transferData'))
      // let componentType = transferData.type
      // if (components.includes(componentType)) {
      //   let component = this.$_.defaultsDeep({}, getDefaultAttr(componentType))
      //   component.position.row = parseInt((index - 1) / this.numberOfColumns) + 1
      //   component.position.col = ((index - 1) % this.numberOfColumns) + 1
      //   this.$store.commit(this.$store.getters['module/getName'] + '/createComponent', {parentComponent: this.component, childComponent: component})
      // }
    },
    getComponent (index) {
      return this.component.children.find(m => {
        return (parseInt(m.position.row) - 1) * this.numberOfColumns + parseInt(m.position.col) === index
      })
    },
    click (event, index) {
      let component = this.getComponent(index)
      if (component) {
        event.stopPropagation()
        let componentVue = this.$children.find(m => m.component === component)
        if (componentVue) {
          componentVue.openAttr()
        }
      }
    },
    removeComponent (index) {
      let component = this.getComponent(index)
      this.$store.commit(this.$store.getters['module/getName'] + '/removeComponent', component)
    }
  },
  computed: {
    getDivNumber () {
      return parseInt(this.component.attr.numberOfColumns) * parseInt(this.component.attr.numberOfLines)
    },
    getStyle () {
      let columns
      if (parseInt(this.component.attr.numberOfColumns) <= 4) {
        let width = 100 / parseInt(this.component.attr.numberOfColumns)
        columns = `repeat(${parseInt(this.component.attr.numberOfColumns)}, ${width}%)`
      } else {
        columns = `repeat(${parseInt(this.component.attr.numberOfColumns)}, 25%)`
      }
      let rows = `repeat(${parseInt(this.component.attr.numberOfLines)}, 62px)`
      return {
        'grid-template-columns': columns,
        'grid-template-rows': rows
      }
    }
  }
}
</script>

<style lang="scss">
  .rc-content-table {
    width: 100%;
    height: 75%;
    .grid-wrapper {
      overflow-x: scroll;
      display: grid;
      grid-gap: 0px;
      >div.item {
        // XXX: 如果有人对框线过粗提出异议, 拿刀
        border: 1px solid #c2c3c4;
        border-radius: 4px;
        background-color: #ffffff;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        i.el-icon-delete {
          font-size: 12px;
          position: absolute;
          top: 2px;
          right: 2px;
          color: #54abf2;
          cursor: pointer;
          &:hover {
            color: #3a8ee6;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/content-table/rc-content-table.vue